import React, { useEffect, useState } from 'react';
import { 
  CustomTab, 
  CustomTabsComponent, 
  MainContentArea,   
  MainContentAreaChildGrid,   
  TabsAndPanelsParentBox, 
  TabsBox
} from './styled';
import RecipeLibraryControl from './TabPanels/RecipeLibraryControl';
import ProfileInfoControl from './TabPanels/ProfileInfoControl';
import MyStatsControl from './TabPanels/MyStatsControl';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomTabPanel from './TabPanels/CustomTabPanel';
// import VideoLibraryControl from './TabPanels/VideoLibraryControl';

function AdminPanel() {

  const navigate = useNavigate();
  const location = useLocation();

  const getCurrentTab = () => {
    const pathToIndex = {
      'profile': 0,
      'library': 1,
      'stats': 2,
      // 'videos': 3,
    };

    const path = location.pathname.split('/').pop();
    return pathToIndex[path] || 0;
  };

  const [value, setValue] = useState(getCurrentTab());
  const [isProfile, setIsProfile] = useState(false);

  const indexToPath = {
    0: 'profile',
    1: 'library',
    2: 'stats',
    // 3: 'videos',
  };

  const handleChange = (_, newValue) => {
    setValue(newValue);
    navigate(`/admin/${indexToPath[newValue]}`);
  };

  useEffect(() => {
    setValue(getCurrentTab());
  }, [location]);

  useEffect(() => {
    if(value === 0){
      setIsProfile(true);
    } else {
      setIsProfile(false);
    }
  }, [value])

  return (
    <MainContentArea elevation={0}>
      <MainContentAreaChildGrid container >
        <TabsAndPanelsParentBox>
          <TabsBox isProfile={isProfile} >
            <CustomTabsComponent 
              variant       = "scrollable" 
              scrollButtons = "auto" 
              value         = {value} 
              onChange      = {handleChange} 
              allowScrollButtonsMobile
            >
              <CustomTab label  = "My Profile" />
              <CustomTab label  = "Library"    />
              {/* <CustomTab label  = "Videos"     /> */}
              <CustomTab label  = "My Stats"   />
            </CustomTabsComponent>
          </TabsBox>
          <CustomTabPanel value={value} index={0} sx={{width: '100%', padding: '0', margin: '0', maxWidth: '100%'}}>
            <ProfileInfoControl />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1} sx={{width: '100%', padding: '0'}}>
            <RecipeLibraryControl />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2} sx={{width: '100%', padding: '0', height: '100%'}}>
            <MyStatsControl />
          </CustomTabPanel>
          {/* <CustomTabPanel value={value} index={3} sx={{width: '100%', padding: '0'}}>
            <VideoLibraryControl />
          </CustomTabPanel> */}
        </TabsAndPanelsParentBox>
      </MainContentAreaChildGrid>
    </MainContentArea>
  )
}

export default AdminPanel